<button class="btn btn-primary mr-1 mb-1" *ngFor="let category of categories" (click)="changeBlock(category)">
    <span class="element-text">{{ category.fullName }}</span>
    <span *ngIf="category.isBlocked"><i class="fas fa-lock"></i></span>
</button>
<button class="btn btn-primary mr-1 mb-1" (click)="changeAllBlocks()">
    <span class="element-text">{{ 'console.all-categories-toggle' | translate }}</span>
</button>